function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

function basic() {
  const cartDrawer = document.querySelector(".cart-drawer");
  if (!cartDrawer) return;

  // Guard: confetti may not be loaded yet
  if (typeof window.confetti === "undefined" || !window.confetti || !window.confetti.create) return;

  // Create a new canvas inside the cart drawer
  const canvas = document.createElement("canvas");
  canvas.style.position = "absolute";
  canvas.style.top = "0";
  canvas.style.left = "0";
  canvas.style.width = "100%";
  canvas.style.height = "100%";
  cartDrawer.appendChild(canvas);

  // Use the canvas for confetti
  const myConfetti = confetti.create(canvas, { resize: true });

  myConfetti({
    particleCount: 1000,
    spread: 300,
    origin: { y: 1.0 }
  });

  // Remove canvas after animation
  setTimeout(() => {
    if (canvas && canvas.parentNode) canvas.remove();
  }, 2000);
}

function add_to_cart_iteam(th) {
  let loader_html_svg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="26" display="block" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100" style="margin: 0px auto; background: none;"><circle cx="50" cy="50" r="35" fill="none" stroke="white" stroke-dasharray="164.93361431346415 56.97787143782138" stroke-width="10"><animateTransform attributeName="transform" dur="0.6s" keyTimes="0;1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"></animateTransform></circle></svg>';

  const cartNotification = document.querySelector(".cart-notification");
  if (cartNotification) cartNotification.style.display = "block";

  if (th) {
    th.innerHTML = loader_html_svg;

    setTimeout(() => {
      // Keep original label
      th.innerHTML = `ADD TO CART`;
    }, 1000);
  }

  setTimeout(() => {
    if (cartNotification) cartNotification.style.display = "none";
  }, 1200);
}

function cart_ref_add_to_cart_iteam(th, tabc = "") {
  let loader_html_svg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" display="block" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100" style="margin: 0px auto; background: none;"><circle cx="50" cy="50" r="35" fill="none" stroke="white" stroke-dasharray="164.93361431346415 56.97787143782138" stroke-width="10"><animateTransform attributeName="transform" dur="0.6s" keyTimes="0;1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"></animateTransform></circle></svg>';

  const cartNotification = document.querySelector(".cart-notification");
  if (cartNotification) cartNotification.style.display = "block";

  if (th) {
    th.innerHTML = loader_html_svg;

    setTimeout(() => {
      th.innerHTML = `+ ADD`;
    }, 1000);
  }

  setTimeout(() => {
    if (cartNotification) cartNotification.style.display = "none";
    //if (tabc) restoreCartTab(tabc);
  }, 1700);
}

function restoreCartTab(tabc) {
  const ids = [`cart_tab_${tabc}`, `cart_tab_1_${tabc}`];

  const findVisible = () => {
    let elA = document.getElementById(ids[0]);
    let elB = document.getElementById(ids[1]);
    const isVisible = (el) => el && el.offsetParent !== null;
    return isVisible(elA) ? elA : (isVisible(elB) ? elB : (elA || elB));
  };

  const tryClick = () => {
    const tabEl = findVisible();
    if (!tabEl) return false;

    const alreadyActive =
      tabEl.classList.contains("active") ||
      tabEl.getAttribute("aria-selected") === "true";

    if (!alreadyActive) tabEl.click();
    return true;
  };

  if (tryClick()) return;

  // Wait briefly for re-render then try again once
  setTimeout(() => {
    tryClick();
  }, 150);
}

function set_cart_counter() {
  let xhr = new XMLHttpRequest();
  let url = "/cart.js";
  xhr.open("GET", url, true);

  xhr.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      let data;
      try {
        data = JSON.parse(this.responseText);
      } catch (e) {
        return;
      }

      var elem = document.querySelector(".header__cart-dot");
      if (elem && !elem.classList.contains("is-visible")) {
        elem.classList.add("is-visible");
      }

      let price_w_shiiping = Number(data.total_price || 0) + 5000;

      let cart_price = formatMoney(data.original_total_price);
      let set_goal_properties =
        cart_price <= progressbar_discount_first ? cart_price : data.item_count;

      const cartCountMain = document.getElementById("cart_count_main");
      if (cartCountMain) cartCountMain.innerHTML = set_goal_properties;

      const cartShippingPrice = document.getElementById("cart_shipping_price");
      const checkoutPriceCart = document.querySelector(".checkout-price-cart");

      if (set_goal_properties >= 6) {
        if (cartShippingPrice) {
          cartShippingPrice.innerHTML = `<span style="text-decoration-line:line-through">₹50</span> &nbsp; FREE`;
        }
        if (checkoutPriceCart) {
          checkoutPriceCart.innerHTML = formatMoney(data.total_price, moneyFormat);
        }
      } else {
        if (cartShippingPrice) cartShippingPrice.innerHTML = "₹50";
        if (checkoutPriceCart) {
          checkoutPriceCart.innerHTML = formatMoney(price_w_shiiping, moneyFormat);
        }
      }
    }
  };

  xhr.send();
}

function progress_bar_fun(data) {
  if (data.item_count > 0) {
    let discounted_amout = 0;

    if (!data || typeof data.item_count === "undefined") {
      console.error("Invalid data received. 'item_count' is missing.");
      return;
    }

    let freeoffphase = document.getElementById("freeoffphase");
    let firstoffphase = document.getElementById("firstoffphase");
    let secondoffphase = document.getElementById("secondoffphase");
    let summary_discount = document.getElementById("summary_discount");
    let summary_shipping = document.getElementById("shipping_price");
    let discounted_amount_txt = document.getElementById("discounted_amount_txt");
    let body_main = document.getElementById("body_main");
    let summary_container = document.getElementById("summary_shipping");
    let shipping_label = document.getElementById("shipping_label");

    if (summary_container) summary_container.style.borderBottom = "none";

    let total_cart_price = 0;
    let total_cart_cprice = 0;
    let old_cart_item_count = 0;

    if (body_main) {
      old_cart_item_count = Number(body_main.getAttribute("old_cart_item_count")) || 0;
    }

    const totalCartPriceEl = document.getElementById("total_cart_price");
    if (totalCartPriceEl) {
      total_cart_price = Number(totalCartPriceEl.getAttribute("data-total-price")) || 0;
    }

    const totalCartCpriceEl = document.getElementById("total_cart_cprice");
    if (totalCartCpriceEl) {
      total_cart_cprice = Number(totalCartCpriceEl.getAttribute("data-total-cprice")) || 0;
    }

    const progressBar = document.getElementById("progressbarfilluppp");
    if (!progressBar) {
      console.error("Element with ID 'progressbarfilluppp' not found.");
      return;
    }

    let width = 0;

    const segment = 100 / 3;

    let price_threshold = Number(progressbar_discount_first) || 0;
    let cart_total_now_1 = Number(total_cart_price) || 0;

    let qty_second = Number(progressbar_discount_second) || 0;
    let qty_third = Number(progressbar_discount_third) || 0;

    const clamp01 = (v) => Math.max(0, Math.min(1, v));

    if (price_threshold > 0 && cart_total_now_1 < price_threshold) {
      width = clamp01(cart_total_now_1 / price_threshold) * segment;
    } else if (qty_second > 0 && Number(data.item_count) < qty_second) {
      width = segment + clamp01(Number(data.item_count) / qty_second) * segment;
    } else if (qty_third > 0 && Number(data.item_count) < qty_third) {
      const denom = (qty_third - qty_second) || 1;
      width =
        2 * segment +
        clamp01((Number(data.item_count) - qty_second) / denom) * segment;
    } else {
      width = 100;
    }

    progressBar.style.width = `${width}%`;

    const textElement = document.querySelector(".pro-text-all");
    if (!textElement) {
      console.error("Element with class 'pro-text-all' not found.");
      return;
    }

    let first_price_threshold = Number(progressbar_discount_first) || 0;
    let cart_total_now = Number(total_cart_price) || 0;
    let is_first_unlocked = cart_total_now >= first_price_threshold;

    let old_cart_price = 0;
    if (body_main) {
      old_cart_price = Number(body_main.getAttribute("old_cart_price")) || 0;
    }

    if (
      (cart_total_now > old_cart_price &&
        old_cart_price < first_price_threshold &&
        cart_total_now >= first_price_threshold) ||
      (data.item_count > old_cart_item_count &&
        (data.item_count == progressbar_discount_second ||
          data.item_count == progressbar_discount_third))
    ) {
      basic();
    }

    if (!is_first_unlocked) {
      let left_amount = first_price_threshold - cart_total_now;
      if (left_amount < 0) left_amount = 0;

      let msg = free_shipping_msg.replace(`{item_count}`, formatMoney(left_amount));
      textElement.innerHTML = msg;

      
      if (total_cart_cprice > 0) {
        discounted_amout = total_cart_cprice - total_cart_price;
        
      }
      discounted_amout = formatMoney(discounted_amout);
      let disc_message = discount_msg;
      let new_discount_msg = disc_message.replace(`{discount_price}`, `${discounted_amout}`);

      
      let final_msg = total_cart_cprice == 0 ? cart_drawer_empty : new_discount_msg;
      
      if (discounted_amount_txt) 
        {discounted_amount_txt.innerHTML = final_msg;}

      if (freeoffphase) freeoffphase.classList.remove("m-active");
      if (firstoffphase) firstoffphase.classList.remove("m-active");
      if (secondoffphase) secondoffphase.classList.remove("m-active");
      if (summary_discount) summary_discount.style.display = "none";
      if (summary_shipping) summary_shipping.innerHTML = `<span>₹${free_shipping_price / 100}</span>`;
      if (summary_container) summary_container.style.marginBottom = "0px";
    } else if (data.item_count < progressbar_discount_second) {
      let pack = progressbar_discount_second - Number(data.item_count);
      let msg = first_discount_msg.replace(`{item_count}`, pack);
      textElement.innerHTML = msg;

      if (total_cart_cprice > 0) {
        discounted_amout = total_cart_cprice - total_cart_price;
      }
      discounted_amout = Number(discounted_amout) + Number(free_shipping_price);
      discounted_amout = formatMoney(discounted_amout);

      let disc_message = discount_msg;
      let new_discount_msg = disc_message.replace(`{discount_price}`, `${discounted_amout}`);

      let final_msg = total_cart_cprice == 0 ? cart_drawer_empty : new_discount_msg;
      if (discounted_amount_txt) discounted_amount_txt.innerHTML = final_msg;

      if (freeoffphase) freeoffphase.classList.add("m-active");
      if (firstoffphase) firstoffphase.classList.remove("m-active");
      if (secondoffphase) secondoffphase.classList.remove("m-active");
      if (summary_discount) summary_discount.style.display = "none";
      if (summary_shipping) summary_shipping.innerHTML = `<span>FREE <del>₹${free_shipping_price / 100}</del></span>`;
      if (summary_container) summary_container.style.marginBottom = "0px";
    } else if (
      data.item_count >= progressbar_discount_second &&
      data.item_count < progressbar_discount_third
    ) {
      let pack = progressbar_discount_third - Number(data.item_count);
      let msg = second_discount_msg.replace(`{item_count}`, pack);
      textElement.innerHTML = msg;

      if (total_cart_cprice > 0) {
        discounted_amout = total_cart_cprice - total_cart_price;
      }
      discounted_amout = Number(discounted_amout) + Number(free_shipping_price);
      discounted_amout = Number(discounted_amout) + Number(data.total_discount);
      discounted_amout = formatMoney(discounted_amout);

      let disc_message = discount_msg;
      let new_discount_msg = disc_message.replace(`{discount_price}`, `${discounted_amout}`);

      if (discounted_amount_txt) discounted_amount_txt.innerHTML = new_discount_msg;

      if (freeoffphase) freeoffphase.classList.add("m-active");
      if (firstoffphase) firstoffphase.classList.add("m-active");
      if (secondoffphase) secondoffphase.classList.remove("m-active");
      if (summary_discount) summary_discount.style.display = "flex";
      if (summary_shipping) summary_shipping.innerHTML = `<span>FREE <del>₹${free_shipping_price / 100}</del></span>`;
      if (summary_container) {
        summary_container.style.marginBottom = "10px";
        summary_container.style.borderBottom = "1px dashed #ccc";
      }
    } else if (data.item_count >= progressbar_discount_third) {
      textElement.innerHTML = third_discount_msg;

      if (total_cart_cprice > 0) {
        discounted_amout = total_cart_cprice - total_cart_price;
      }
      discounted_amout = Number(discounted_amout) + Number(free_shipping_price);
      discounted_amout = Number(discounted_amout) + Number(data.total_discount);
      discounted_amout = formatMoney(discounted_amout);
      
      let disc_message = discount_msg;
      let new_discount_msg = disc_message.replace(`{discount_price}`, `${discounted_amout}`);

      if (discounted_amount_txt) discounted_amount_txt.innerHTML = new_discount_msg;

      if (freeoffphase) freeoffphase.classList.add("m-active");
      if (firstoffphase) firstoffphase.classList.add("m-active");
      if (secondoffphase) secondoffphase.classList.add("m-active");
      if (summary_discount) summary_discount.style.display = "flex";
      if (summary_shipping) summary_shipping.innerHTML = `<span>FREE <del>₹${free_shipping_price / 100}</del></span>`;
      if (summary_container) {
        summary_container.style.marginBottom = "10px";
        summary_container.style.borderBottom = "1px dashed #ccc";
      }
    }

    // IMPORTANT: body_main can be null, so guard it
    if (body_main) {
      body_main.setAttribute("old_cart_item_count", data.item_count);
      body_main.setAttribute("old_cart_price", cart_total_now);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  let xhr = new XMLHttpRequest();
  let url = "/cart.js";
  xhr.open("GET", url, true);

  xhr.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      let data;
      try {
        data = JSON.parse(this.responseText);
      } catch (e) {
        return;
      }

      progress_bar_fun(data);

      let cart_product_items = data.items || [];
      let cart_item_count = Number(cart_product_items.length) || 0;
      let ii = 0;

      for (; ii < cart_item_count; ii++) {
        let product_id = cart_product_items[ii].product_id;
        let product = document.querySelectorAll(`[data-product-id="${product_id}"]`);
        if (product && product.length > 0) {
          product[0]["style"]["display"] = "none";
        }
      }
    }
  };

  xhr.send();
});

window.addEventListener("load", function () {
  // Lazy load images (safe)
  document.querySelectorAll("img:not([loading])").forEach((img) => {
    img.setAttribute("loading", "lazy");
  });

  // SAFER: do not mutate defer for scripts that are already in the DOM and may have executed.
  // If you really need this behavior, it should be done server-side or before scripts are parsed.
  // Keeping your intent, but minimizing damage:
  document.querySelectorAll('script[src]:not([defer]):not([async])').forEach((script) => {
    const src = script.getAttribute("src") || "";
    if (!src.includes("gtag") && !src.includes("gtm") && !src.includes("critical")) {
      // Setting defer after load does not improve performance and can cause confusion.
      // We keep it here only because your original code did it.
      script.setAttribute("defer", "true");
    }
  });
});

(function () {
    function initPcSwipers() {
      // If Swiper is not available, do nothing
      if (typeof window.Swiper === 'undefined') return;

      document.querySelectorAll('.pc-swiper-wrapper').forEach(function (wrapper) {
        // Avoid double-init
        if (wrapper.dataset.pcSwiperInited === 'true') return;
        wrapper.dataset.pcSwiperInited = 'true';

        var mainEl = wrapper.querySelector('.pc-swiper-main');
        var thumbsEl = wrapper.querySelector('.pc-swiper-thumbs');

        if (!mainEl || !thumbsEl) return;

        // --- Thumbnails Swiper ---
        var thumbsSwiper = new Swiper(thumbsEl, {
          slidesPerView: 10,
          spaceBetween: 8,
          freeMode: true,
          watchSlidesProgress: true,
          watchOverflow: true,
          grabCursor: true,
          breakpoints: {
            0:   { slidesPerView: 10, spaceBetween: 6 },
            768: { slidesPerView: 10, spaceBetween: 8 }
          }
        });

        // Build main swiper config
        var mainConfig = {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: true,
          watchOverflow: true,
          preloadImages: false,
          lazy: { loadOnTransitionStart: true },
          pagination: {
            el: mainEl.querySelector('.swiper-pagination'),
            clickable: true
          },
          thumbs: {
            swiper: thumbsSwiper
          },
          threshold: 3
        };

        // Only add navigation if buttons actually exist
        var nextEl = mainEl.querySelector('.swiper-button-next');
        var prevEl = mainEl.querySelector('.swiper-button-prev');
        if (nextEl && prevEl) {
          mainConfig.navigation = {
            nextEl: nextEl,
            prevEl: prevEl
          };
        }

        new Swiper(mainEl, mainConfig);
      });
    }

    function waitForSwiperAndInit() {
      if (typeof window.Swiper === 'undefined') {
        // Swiper script not yet loaded – try again shortly
        setTimeout(waitForSwiperAndInit, 50);
      } else {
        initPcSwipers();
      }
    }

    // Run on initial page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForSwiperAndInit);
    } else {
      waitForSwiperAndInit();
    }

    // Re-run when Shopify dynamically reloads sections (theme editor, etc.)
    document.addEventListener('shopify:section:load', waitForSwiperAndInit);
    document.addEventListener('shopify:section:reorder', waitForSwiperAndInit);
  })();